<template>
    <el-dialog :visible.sync="popupModal" width="508px" top="16vh"
        :title="actionType === 0 ? $t('operation.rule.addChild') : $t('operation.rule.editChild')">
        <el-form :model="ruleForm" :rules="rules" ref="modalForm" label-width="140px" style="width: 450px;">
            <el-form-item :label="$t('operation.rule.childName') + '：'" key="name" prop="name">
                <el-input :placeholder="$t('common.inputplaceholder')" v-model="ruleForm.name" size="medium"
                    maxlength="32"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="popupModal = false" class="sys-btn-default">{{ $t('common.cancel') }}</el-button>
            <el-button @click="saveData" type="primary">{{ $t('common.confirm') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import Cookies from 'js-cookie'
export default {
    data() {
        return {
            popupModal: false,
            ruleForm: {
                name: null,
            },
            rules: {
                name: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur' }],
            },
            actionType: 0, // 0:add 1:update
            monitorId: Number(Cookies.get("monitorId")),
        }
    },
    created() {

    },
    methods: {
        close() {
            this.popupModal = false;
        },
        open(type, row) {
            this.actionType = type;
            this.popupModal = true;
            this.$nextTick(() => {
                this.$refs.modalForm.resetFields();
                if (type === 1) {
                    this.ruleForm.name = row.name;
                }
            })
        },
        saveData() {
            this.$refs.modalForm.validate((valid) => {
                if (!valid) {
                    return false;
                } else {
                    this.$emit("closeAddModal", this.actionType, this.ruleForm);
                }
            })
        }
    }
}
</script>